import { SYSTEM_VOICEBOX_INSTRUCTIONS_IRI } from 'src/templates/queries/iris';

/**
 * Queries for voicebox instructions stored on the named graph metadata.
 *
 * **Call Frequency**
 *
 * Called once when a model is added to a project or refreshed.
 *
 * **Context**
 * - Named graphs: set by the user (default is `reasoning.schema.graphs` value,
 *   which by default is `tag:stardog:api:context:local`)
 * - Reasoning: always off
 *
 * **Example**
 * ```sparql
 * # Voicebox Instructions
 * SELECT ?voiceboxInstructions
 * WHERE {
 *   ?s <http://system.stardog.com/voiceboxInstructions> ?voiceboxInstructions .
 * }
 * ```
 */
export const voiceboxInstructionsQuery = `# Voicebox Instructions
SELECT ?voiceboxInstructions
WHERE {
  ?s <${SYSTEM_VOICEBOX_INSTRUCTIONS_IRI}> ?voiceboxInstructions .
}`;
